var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "_container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        [
          _c("h3", [_vm._v("Bygg")]),
          _vm._v(" "),
          _c("p", [_vm._v("Velg bygg")]),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "c-btn c-btn--invisible",
              class: {
                "is-active": _vm.selectedBuilding === "all"
              },
              attrs: { for: "building-all" }
            },
            [
              _c("Toggle", {
                staticClass:
                  "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                attrs: { isSelected: _vm.selectedBuilding === "all" }
              }),
              _vm._v("\n        Alle\n        "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedBuilding,
                    expression: "selectedBuilding"
                  }
                ],
                staticClass: "screen-reader-text",
                attrs: { id: "building-all", type: "radio", value: "all" },
                domProps: { checked: _vm._q(_vm.selectedBuilding, "all") },
                on: {
                  change: function($event) {
                    _vm.selectedBuilding = "all"
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.buildings, function(building) {
            return _c(
              "label",
              {
                key: building.id,
                staticClass: "c-btn c-btn--invisible",
                class: {
                  "is-active": _vm.selectedBuilding === building.id
                },
                attrs: { for: "building-" + building.slug }
              },
              [
                _c("Toggle", {
                  staticClass:
                    "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                  attrs: { isSelected: _vm.selectedBuilding === building.id }
                }),
                _vm._v("\n        " + _vm._s(building.name) + "\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedBuilding,
                      expression: "selectedBuilding"
                    }
                  ],
                  staticClass: "screen-reader-text",
                  attrs: { id: "building-" + building.slug, type: "radio" },
                  domProps: {
                    value: building.id,
                    checked: _vm._q(_vm.selectedBuilding, building.id)
                  },
                  on: {
                    change: function($event) {
                      _vm.selectedBuilding = building.id
                    }
                  }
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h3", [_vm._v("Salgsstatus")]),
          _vm._v(" "),
          _c("p", [_vm._v("Velg salgsstatus")]),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "c-btn c-btn--invisible",
              class: {
                "is-active": _vm.availabilityState === "all"
              },
              attrs: { for: "availability-all" }
            },
            [
              _c("Toggle", {
                staticClass:
                  "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                attrs: { isSelected: _vm.availabilityState === "all" }
              }),
              _vm._v("\n        Alle\n        "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.availabilityState,
                    expression: "availabilityState"
                  }
                ],
                staticClass: "screen-reader-text",
                attrs: { id: "availability-all", value: "all", type: "radio" },
                domProps: { checked: _vm._q(_vm.availabilityState, "all") },
                on: {
                  change: function($event) {
                    _vm.availabilityState = "all"
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.availabilities, function(availability) {
            return _c(
              "label",
              {
                key: availability.id,
                staticClass: "c-btn c-btn--invisible",
                class: {
                  "is-active": _vm.availabilityState === availability.slug
                },
                attrs: { for: "availability-" + availability.slug }
              },
              [
                _c("Toggle", {
                  staticClass:
                    "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                  attrs: {
                    isSelected: _vm.availabilityState === availability.slug
                  }
                }),
                _vm._v("\n        " + _vm._s(availability.name) + "\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.availabilityState,
                      expression: "availabilityState"
                    }
                  ],
                  staticClass: "screen-reader-text",
                  attrs: {
                    id: "availability-" + availability.slug,
                    type: "radio"
                  },
                  domProps: {
                    value: availability.slug,
                    checked: _vm._q(_vm.availabilityState, availability.slug)
                  },
                  on: {
                    change: function($event) {
                      _vm.availabilityState = availability.slug
                    }
                  }
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h3", [_vm._v("Pris")]),
          _vm._v(" "),
          _c("p", [_vm._v("Velg pris fra – til")]),
          _vm._v(" "),
          _c("filter-price-input")
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c("h3", [_vm._v("Størrelse")]),
        _vm._v(" "),
        _c("p", [_vm._v("Velg størrelse fra – til")]),
        _vm._v(" "),
        _c("label", { attrs: { for: "minSizeInput" } }, [
          _vm._v("Fra m²:\n        "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.minSize,
                expression: "minSize"
              }
            ],
            attrs: { id: "minSizeInput", type: "number" },
            domProps: { value: _vm.minSize },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.minSize = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("label", { attrs: { for: "maxSizeInput" } }, [
          _vm._v("Til m²:\n        "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.maxSize,
                expression: "maxSize"
              }
            ],
            attrs: { id: "maxSizeInput", type: "number" },
            domProps: { value: _vm.maxSize },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.maxSize = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h3", [_vm._v("Sortering")]),
          _vm._v(" "),
          _c("p", [_vm._v("Velg ønsket sortering")]),
          _vm._v(" "),
          _c("sorter")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h3", [_vm._v("Soverom")]),
          _vm._v(" "),
          _c("p", [_vm._v("Velg antall soverom")]),
          _vm._v(" "),
          _c("select-bedrooms")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h3", [_vm._v("Bad")]),
          _vm._v(" "),
          _c("p", [_vm._v("Velg antall bad")]),
          _vm._v(" "),
          _c("select-bathrooms")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h3", [_vm._v("Boligtype")]),
          _vm._v(" "),
          _c("p", [_vm._v("Velg type bolig")]),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "c-btn c-btn--invisible",
              class: {
                "is-active": _vm.selectedResidenceType === "all"
              },
              attrs: { for: "type-all" }
            },
            [
              _c("Toggle", {
                staticClass:
                  "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                attrs: { isSelected: _vm.selectedResidenceType === "all" }
              }),
              _vm._v("\n        Alle\n        "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedResidenceType,
                    expression: "selectedResidenceType"
                  }
                ],
                staticClass: "screen-reader-text",
                attrs: { id: "type-all", type: "radio" },
                domProps: {
                  value: "all",
                  checked: _vm._q(_vm.selectedResidenceType, "all")
                },
                on: {
                  change: function($event) {
                    _vm.selectedResidenceType = "all"
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.residenceTypes, function(type) {
            return _c(
              "label",
              {
                key: type.id,
                staticClass: "c-btn c-btn--invisible",
                class: {
                  "is-active": _vm.selectedResidenceType === type.slug
                },
                attrs: { for: "type-" + type.slug }
              },
              [
                _c("Toggle", {
                  staticClass:
                    "c-btn__icon c-btn__icon--left c-btn__icon--alignment",
                  attrs: { isSelected: _vm.selectedResidenceType === type.slug }
                }),
                _vm._v("\n        " + _vm._s(type.name) + "\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedResidenceType,
                      expression: "selectedResidenceType"
                    }
                  ],
                  staticClass: "screen-reader-text",
                  attrs: { id: "type-" + type.slug, type: "radio" },
                  domProps: {
                    value: type.slug,
                    checked: _vm._q(_vm.selectedResidenceType, type.slug)
                  },
                  on: {
                    change: function($event) {
                      _vm.selectedResidenceType = type.slug
                    }
                  }
                })
              ],
              1
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "_sticky" },
        [
          _c("residence-list"),
          _vm._v(" "),
          _c("residence-counter"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "c-btn c-btn--primary",
              on: { click: _vm.queryURL }
            },
            [_vm._v("\n        Gå til URL\n      ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "_full" }, [
      _c("h2", [_vm._v("URL bygger")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Her kan du bygge en URL med et forhåndsdefinert filter for boliger."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }